import { render } from "./AddOrEditAdmin.vue?vue&type=template&id=e65cf872"
import script from "./AddOrEditAdmin.vue?vue&type=script&lang=js"
export * from "./AddOrEditAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__